(ns serv-ui.auth
  "The key this browser signs in with, kept in localStorage. Nothing else
  about the session is stored: the key is the session."
  (:refer-clojure :exclude [key]))

(def ^:private key-item "serv-key")
(def ^:private email-item "serv-email")
(def ^:private device-item "serv-device")

(defn- storage [] (.-localStorage js/window))

(defn key [] (.getItem (storage) key-item))
(defn signed-in? [] (boolean (seq (key))))
(defn remember-key! [k] (.setItem (storage) key-item k))
(defn forget-key! [] (.removeItem (storage) key-item))

(defn last-email [] (.getItem (storage) email-item))
(defn remember-email! [e] (.setItem (storage) email-item e))

(defn last-device []
  (or (.getItem (storage) device-item)
      (.getItem (storage) "serv-key-name")))
(defn remember-device! [d] (.setItem (storage) device-item d))
